import { create } from 'zustand';
import { ActionEntityType, ExportTemplateResponse, getAllExportTemplates } from '@pmp/api';

type ExportTemplatesStore = {
  isLoadingExportTemplates: boolean;
  getExportTemplates: (entityType: ActionEntityType) => Promise<ExportTemplateResponse[]>;
  getAllExportTemplates: () => Promise<ExportTemplateResponse[]>;
};

export const useExportTemplatesStore = create<ExportTemplatesStore>((set, get) => {
  let exportTemplates: Record<string, ExportTemplateResponse[]> = {};
  let allExportTemplates: ExportTemplateResponse[] = [];

  return {
    isLoadingExportTemplates: false,

    getAllExportTemplates: async () => {
      set({ isLoadingExportTemplates: true });

      try {
        const { data } = await getAllExportTemplates();

        exportTemplates = data.reduce(
          (acc, template) => {
            acc[template.entityType.key] = acc[template.entityType.key] || [];
            acc[template.entityType.key].push(template);
            return acc;
          },
          {} as Record<string, ExportTemplateResponse[]>,
        );

        allExportTemplates = data;
        return allExportTemplates;
      } catch (error) {
        console.error('Failed to load export templates:', error);
        throw error;
      } finally {
        set({ isLoadingExportTemplates: false });
      }
    },

    getExportTemplates: async (entityType: ActionEntityType) => {
      if (exportTemplates[entityType]) {
        return exportTemplates[entityType];
      }

      await get().getAllExportTemplates();
      return exportTemplates[entityType] || [];
    },
  };
});
